<div class="tab-container">
    <div class="menu-principal">
        <!-- Contenido del menú principal -->
    </div>
    <div class="button-group">
        <!--<button (click)="selectTab(0)">Coordinators</button>-->
        <!--<button (click)="selectTab(1)">Despacho Colaboradores</button>-->
        <!--<button (click)="selectTab(2)">Despacho Coordinadores</button>-->
        <!--<button (click)="selectTab(3)">Visitas Empresa</button>-->
    </div>

    <mat-tab-group [selectedIndex]="selectedIndex">
        <mat-tab label="Coordinadores">
            <app-coordinators></app-coordinators>
        </mat-tab>
        <mat-tab label="Despacho Colaboradores">
            <app-despacho-colaboradores></app-despacho-colaboradores>
        </mat-tab>
        <mat-tab label="Despacho Coordinadores">
            <app-despacho-coordinadores></app-despacho-coordinadores>
        </mat-tab>
        <mat-tab label="Visitas Empresa">
            <app-visitas-empresa></app-visitas-empresa>
        </mat-tab>
    </mat-tab-group>
</div>
